<template>
  <div class="main-content bg-default">
    <base-nav
      v-model="showMenu"
      :transparent="true"
      menu-classes="justify-content-end"
      class="navbar-horizontal navbar-main navbar-top navbar-light"
      expand="lg"
    >
      <div
        slot="brand"
        class="navbar-wrapper logo"
        :class="isAdmin || isAdminServiceLines ? 'col-lg-4' : ''"
      >
        <router-link to="/">
          <img src="img/brand/logo_astek_black.png" />
        </router-link>
      </div>

      <div
        class="
          navbar-custom-collapse
          collapse
          navbar-collapse
          collapse
          justify-content-center
        "
      >
        <h1 class="display-5">{{ $t("header.title") }}</h1>
      </div>

      <template>
        <div class="navbar-collapse-header">
          <b-row>
            <b-col cols="6" class="collapse-brand">
              <img src="img/brand/logo_astek_black.png" />
            </b-col>
            <b-col cols="6" class="collapse-close">
              <button
                type="button"
                class="navbar-toggler"
                @click="showMenu = false"
              >
                <span></span>
                <span></span>
              </button>
            </b-col>
          </b-row>
        </div>

        <b-navbar-nav
          class="mobile-nav align-items-lg-center ml-lg-auto d-block d-lg-none"
        >
          <b-nav-item :key="item.id" v-for="item in menus" :to="item.url">
            <span class="nav-link-inner--text">{{ item.label }}</span>
          </b-nav-item>
          <b-nav-item>
            <span
              class="nav-link-inner--text"
              @click="setLanguage('fr')"
              :class="[language == 'fr' ? 'language active' : 'language']"
              >{{ $t("language.fr") }}</span
            >
            |
            <span
              class="nav-link-inner--text"
              @click="setLanguage('en')"
              :class="[language == 'en' ? 'language active' : 'language']"
              >{{ $t("language.en") }}</span
            >
            |
            <span
              class="nav-link-inner--text"
              @click="setLanguage('pl')"
              :class="[language == 'pl' ? 'language active' : 'language']"
              >{{ $t("language.pl") }}</span
            >
          </b-nav-item>
        </b-navbar-nav>
        <div class="d-none d-lg-block">
          <b-navbar-nav class="align-items-lg-center ml-lg-auto">
            <b-nav-item v-if="isAdmin || isAdminServiceLines">
              <router-link class="text-dark pr-2" :to="redirectUrlAdmin">
                <span class="nav-link-inner--text">{{
                  $t("admin.menu.adminaccess")
                }}</span>
              </router-link>
            </b-nav-item>
            <b-nav-item
              @click="setLanguage('fr')"
              class="language"
              :class="[language == 'fr' ? 'active' : '']"
            >
              <el-tooltip
                placement="bottom"
                :content="$t('tooltip.language.fr')"
              >
                <span class="nav-link-inner--text">{{
                  $t("language.fr")
                }}</span>
              </el-tooltip>
            </b-nav-item>
            |
            <b-nav-item
              @click="setLanguage('en')"
              class="language pr-2"
              :class="[language == 'en' ? 'active' : '']"
            >
              <el-tooltip
                placement="bottom"
                :content="$t('tooltip.language.en')"
              >
                <span class="nav-link-inner--text">{{
                  $t("language.en")
                }}</span>
              </el-tooltip>
            </b-nav-item>
            |
            <b-nav-item
              @click="setLanguage('pl')"
              class="language pr-2"
              :class="[language == 'pl' ? 'active' : '']"
            >
              <el-tooltip
                placement="bottom"
                :content="$t('tooltip.language.pl')"
              >
                <span class="nav-link-inner--text">{{
                  $t("language.pl")
                }}</span>
              </el-tooltip>
            </b-nav-item>
            <b-nav-item>
              <b-link @click="logout">
                <el-tooltip placement="bottom" :content="$t('tooltip.logout')">
                  <i class="icon-xs"
                    ><b-img alt="..." src="./img/icons/common/logout.svg"
                  /></i>
                </el-tooltip>
              </b-link>
            </b-nav-item>
          </b-navbar-nav>
        </div>
      </template>
    </base-nav>

    <user-menu
      class="d-none d-lg-block"
      :style="{ backgroundImage: 'url(img/theme/header-background.png)' }"
    ></user-menu>

    <div class="main-content">
      <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
        <router-view></router-view>
      </zoom-center-transition>
    </div>

    <user-footer></user-footer>
  </div>
</template>
<script>
import Vue from "vue";
import { BaseNav } from "@/components";
import { ZoomCenterTransition } from "vue2-transitions";
import UserFooter from "./UserFooter";
import UserMenu from "./UserMenu";
import { PublicClientApplication } from "@azure/msal-browser";

export default {
  components: {
    BaseNav,
    ZoomCenterTransition,
    UserMenu,
    UserFooter,
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black",
    },
  },
  data() {
    let user = this.$store.getters.User;
    return {
      isAdmin: user.usr_admin,
      isAuthEmailEnabled: process.env.VUE_APP_AUTH_DEMO_ENABLED === "1",
      isAdminServiceLines: user.usr_adminservicelines,
      showMenu: false,
      language: Vue.i18n.locale(),
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
      pageClass: "login-page",
      menus: [
        {
          id: 1,
          name: "home",
          label: "ta vie chez astek",
          icon: "img/icons/common/map-book.svg",
          url: "/",
        },
        {
          id: 2,
          name: "tools",
          label: "outils",
          icon: "img/icons/common/tools.svg",
          url: "/tools",
        },
        {
          id: 3,
          name: "cooptation",
          label: "cooptation",
          icon: "img/icons/common/hands-helping.svg",
          url: "/cooptation",
        },
        {
          id: 4,
          name: "actus",
          label: "communication",
          icon: "img/icons/common/cog.svg",
          url: "/actus",
        },
        {
          id: 5,
          name: "share",
          label: "Développe tes compétences",
          icon: "img/icons/common/cog.svg",
          url: "/share",
        },
        {
          id: 6,
          name: "admin",
          label: "Accès administrateur",
          icon: "img/icons/common/cog.svg",
          url: "/blogs",
        },
      ],
      styles: {
        titleStyle: {
          marginBottom: "0px",
          fontSize: "large",
          fontWeight: "600",
        },
      },
    };
  },
  async created() {
    this.$msalInstance = new PublicClientApplication(
      this.$store.state.msalConfig
    );
  },
  computed: {
    title() {
      return `${this.$route.name} Page`;
    },
    redirectUrlAdmin() {
      if (this.isAdmin) return "/blogs";
      if (this.isAdminServiceLines) return "/meetup";
    },
  },
  methods: {
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    setBackgroundColor() {
      document.body.classList.add("bg-default");
    },
    removeBackgroundColor() {
      document.body.classList.remove("bg-default");
    },
    updateBackground() {
      if (!this.$route.meta.noBodyBackground) {
        this.setBackgroundColor();
      } else {
        this.removeBackgroundColor();
      }
    },
    setLanguage(locale) {
      Vue.i18n.set(locale);
      this.language = locale;
      localStorage.setItem(Vue.Keys.LANGUAGE, locale);
      this.$router.go();
    },

    async logout() {
      if(this.isAuthEmailEnabled) {
        await this.$store.dispatch("LogOut");
        this.$router.push("/login");
      }else
        await this.SignOut();
    },
    async SignOut() {
      this.account = null;
      this.$store.dispatch("LogOut");
      await this.$msalInstance
        .logout({});
        // .then(() => {
        //   this.$store.dispatch("LogOut");
        // })
        // .catch(() => {
        //   this.$store.dispatch("LogOut");
        // });
    },
  },
  beforeDestroy() {
    this.removeBackgroundColor();
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: function () {
        this.updateBackground();
      },
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}

.main-content .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-content .zoomOut {
  animation-name: zoomOut8;
}
</style>
